<template>
  <div>
    <table class="table mb-0 table-centered">
      <thead class="thead-light">
      <tr>
        <th>#</th>
        <th>Subject</th>
        <th>Status</th>
        <th>Priority</th>
        <th>Difficulty</th>
        <th>Created At</th>
        <th>Agent</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="ticket in results">
        <th scope="row">{{ ticket.id }}</th>
        <td>{{ ticket.subject }}</td>
        <td>{{ getHumanReadableTicketStatus(ticket.status) }}</td>
        <td>{{ getHumanReadableTicketPriority(ticket.priority) }}</td>
        <td>{{ ticket.difficulty }}</td>
        <td>{{ displayTimeAgo(ticket.received_at) }}</td>
        <td>{{ ticket.agent ? ticket.agent.name : '-' }}</td>
        <td class="text-right">
          <!-- Button trigger modal -->
          <button
              type="button"
              class="btn btn-itg btn-itg btn-sm"
              @click="$router.push('/tickets/'+ticket.id)"
          >
            View
          </button>
        </td>
      </tr>
      <tr v-if="results.length === 0">
        <th scope="row" colspan="7">
          <span class="text-danger">No results</span>
        </th>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import Tickets from "../../../../../mixins/Tickets";
import Dates from "../../../../../mixins/Dates";

export default {
  name: "TicketsReportingTable",
  mixins: [Tickets, Dates],
  computed: {
    ...mapGetters('reportEditor', {
      results: 'results'
    })
  }
}
</script>

<style scoped>

</style>